export default {
  surface: {
    itself: 'Area',
    '*': 'Area *',
    required: 'Area is required',
    unit: 'sqm',
  },
};
